import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const getDashboardCasesStatus = (token) => {
  let url = `${baseUrl}/dashboard/casesStatus`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const getDashboardCaseType = (token) => {
  let url = `${baseUrl}/dashboard/casesType`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const getDashboardDueDate = (token) => {
  let url = `${baseUrl}/dashboard/dueCases`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
